import { CustomControlCode } from '@common/enums/serviceWorkflow/customControlCode';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { HolterExaminationFollowingSteps } from '../customComponents/HolterExaminationFollowingSteps';
import { getExaminationRequestReadComponentsBase } from '../utils/getExaminationRequestReadComponentsBase';

export function HolterZorgdomeinExaminationRequestRead(): JSX.Element {
    const { readSections, processActivity } = useDefinedContext(ProcessActivityReadContext);

    return (
        <>
            <ReadForm components={getExaminationRequestReadComponentsBase(readSections, processActivity.id)} />
            <HolterExaminationFollowingSteps holterType={CustomControlCode.HolterZorgdomeinExaminationRequest} />
        </>
    );
}
